import { useEffect, useRef, useState } from 'react';
import { UseHoverSubmenuReturn } from './useHoverSubmenu.types';

export const HOVER_SUBMENU_CLOSE_DELAY = 60;

export const useHoverSubmenu = (): UseHoverSubmenuReturn => {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  const closeTimeoutRef = useRef<ReturnType<typeof setTimeout> | undefined>(undefined);

  const cancelScheduledClose = () => {
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = undefined;
    }
  };

  const open = (event: React.MouseEvent<HTMLElement>) => {
    cancelScheduledClose();
    setAnchorEl(event.currentTarget);
  };

  const close = () => {
    cancelScheduledClose();
    setAnchorEl(null);
  };

  const scheduleClose = () => {
    cancelScheduledClose();
    closeTimeoutRef.current = setTimeout(() => setAnchorEl(null), HOVER_SUBMENU_CLOSE_DELAY);
  };

  useEffect(() => () => clearTimeout(closeTimeoutRef.current), []);

  return {
    isOpen: Boolean(anchorEl),
    close,
    triggerProps: {
      onClick: open,
      onMouseEnter: open,
      onMouseLeave: scheduleClose,
    },
    submenuProps: {
      anchorEl,
      onClose: close,
      onMouseEnter: cancelScheduledClose,
      onMouseLeave: scheduleClose,
    },
  };
};
